const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  careMode: state => state.app.careMode,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  isSuperAdmin: state => {
    const username = (state.user.name || '').toLowerCase()
    const roles = state.user.roles || []
    return (
      username === 'admin' ||
      roles.includes('admin') ||
      roles.includes('ROLE_ADMIN') ||
      roles.includes('超级管理员')
    )
  },
  userId: state => state.user.userId,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js